import { createDependencyHealthStore, degradationMessage } from '@solum/experience'

/** Console-owned instance; the controller mechanics live in Experience. */
export const QUERY_RETRY = 1
export const health = createDependencyHealthStore({ retries: QUERY_RETRY })
export { degradationMessage }
